<template>
    <Loading
        :is-loading="pageData.isLoading"
        :text="pageData.processingText"
    />
</template>

<script setup>
import routeName from '@/router/constant.js';
import router from '@/router';
import Loading from '@/components/Loading.vue';

import { reactive } from 'vue';
import { postReserveVideoLinkLogin } from '@/apis/login';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { postInitTransaction } from '@/apis/CloudECounterReserve';
import aplCatlCode from '@/json/aplCatlCode';
import { startTransaction } from '@/apis/system';

const route = useRoute();
const store = useStore();

const pageData = reactive({
    isLoading: true,
    processingText: '處理中，請稍後',
});

const userData = {
    caseNo: route.query.caseNo,
    type: route.query.type,
};

const login = () => {
    const data = {
        caseNo: userData.caseNo,
        type: userData.type,
    };
    postReserveVideoLinkLogin(data).then((res) => {
        store.dispatch('permissions/setAuth', 'Y');
        store.dispatch('permissions/setUserInfo', res.data);
        pageData.processingText = '處理中...';
    }).then((data) => {
        return postInitTransaction().then((res) => {
            store.dispatch('services/setAplCatl', aplCatlCode.RESERVE_VIDEO);
            store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
        });
    }).then((res) => {
        return startTransaction().then((res) => {
        });
    }).then((res) => {
        router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_HOME });
    }).catch((err) => {
        console.log(err);
        const errorMessage = err?.data?.errorMessage ? err?.data?.errorMessage : '';
        router.push({
            name: routeName.FORBIDDEN,
            params: { errorMessage: errorMessage },
        });
        pageData.isLoading = false;
    });
};

login();

</script>

<style scoped lang="scss">

</style>
